import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { BulkUpdateExpectedClosingDateFormModel } from '../typings'

export const useFormFieldActions = () => {
  const {
    values: { expectedClosingDate },
    setFieldValue,
  } = useFormikContext<BulkUpdateExpectedClosingDateFormModel>()

  const onChangeExpectedClosingDate = useCallback(
    (date: Date | null) => void setFieldValue('expectedClosingDate', date),
    [setFieldValue],
  )

  return {
    expectedClosingDate,
    onChangeExpectedClosingDate,
  }
}
